import { PropsOf } from 'types';
import connect from './connect';
import VideoExportLink from './VideoExportLink';

export default connect(VideoExportLink);
export type VideoExportLinkProps = PropsOf<ReturnType<typeof connect>>;
